import React from 'react';
import { PrivacyPolicyLink, TermsOfServiceLink } from 'components/link';
import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';
import { apostrophiseString } from 'helpers/stringHelpers';
const TermsOfServiceContent = ({ prefix = 'I' }) => (React.createElement("span", null,
    `${prefix} agree to ${apostrophiseString(PLATFORM_DISPLAY_SHORT_NAME)}`,
    ' ',
    React.createElement(TermsOfServiceLink, { className: "text-xs underline" }),
    " and ",
    React.createElement(PrivacyPolicyLink, { className: "text-xs underline" }),
    "."));
export default TermsOfServiceContent;
